import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSelect } from '@angular/material';
import { TamasAlunoService } from '../tamas-aluno.service';
import { FieldsCartao } from '../tamas-models';
import { FormControl } from '@angular/forms';


declare var PagSeguroDirectPayment: any;

@Component({
  selector: 'app-premium-assinar',
  templateUrl: './premium-assinar.component.html',
  styleUrls: ['./premium-assinar.component.css']
})




export class PremiumAssinarComponent implements OnInit {
  //@ViewChild('myDDplans') myDDplans: ElementRef;
  @ViewChild("numeroInput") meuInputNumero: ElementRef;
  @ViewChild("numeroCCInput") meuInputCNumber: ElementRef;
  arrPPlanos: any[] = [];
  planoEscolhido: any = '';
  hideCL: boolean = false;
  nomeAtual: any = '';
  pagarVT: any = 0;
  pagarVTF: any = 0;
  //qPlano: any = '';
  qPlanoId: any = 0;
  nomecc: any = '';
  numerocc: any = '';
  validade: any = '';
  cvv: any = '';
  dadosCC: FieldsCartao = new FieldsCartao();
  checkPremiumDone: boolean = false;
  checkPremiumCase: any = 0;
  arrPlanosPremium: any[] = [];
  userSenderHash: any = '';
  carregouSH: boolean = false;
  logradouro: any = '';
  numero: any = '';
  bairro: any = '';
  cidade: any = '';
  uf: any = '';
  cep: any = '';
  complemento: any = '';
  numerocpf: any = '';
  numerocel: any = '';
  nascimento: any = '';
  meucpf: any = '';
  valorDesconto: any = 0;
  cupomAplicado: boolean = false;
  valorCupom: any = 0;
  cupom: any = '';
  //myDDPlans = new FormControl();

  public maskCEP = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public maskCartao = [/[0-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,];
  public maskValidade = [/[0-9]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskCPF = [/[0-9]/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];
  public maskCelular = ["(", /[0-9]/, /\d/, ")", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/];
  public maskNascimento = [/[0-9]/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public dialog: MatDialog, public tmaService: TamasAlunoService, private ngZone: NgZone) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideCL = true;
    this.nomeAtual = this.tmaService.hcNome;
    //this.pagarVT = 19.90;
    this.qPlanoId = +this.route.snapshot.paramMap.get('idplano');
    this.carregarPlanos();
  }

  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     console.log("load ok");
  //     console.log(this.route.snapshot.paramMap.get('idplano'));

  //     console.log(this.qPlano);
  //     this.qPlanoId = this.route.snapshot.paramMap.get('idplano');
  //   }, 1);
  // }

  carregarPlanos(): void {
    this.tmaService.listarPlanosPremiumPS().subscribe((qRes) => {
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.arrPlanosPremium = qRes["dadosPP"];
        //retornar o id da sessão aqui dentro
        var idSessaoP = qRes["codSession"];
        PagSeguroDirectPayment.setSessionId(idSessaoP);


        if (this.arrPlanosPremium.find(x => x.Id == this.qPlanoId).DescontoAtivo) {
          this.pagarVTF = this.arrPlanosPremium.find(x => x.Id == this.qPlanoId).ValorCD;
          this.pagarVT = this.pagarVTF;
        }
        else {
          this.pagarVTF = this.arrPlanosPremium.find(x => x.Id == this.qPlanoId).ValorCD;
          this.pagarVT = this.pagarVTF;
        }
      }
    })

  }

  buscarCupom(): void {

    if (this.cupom == '') {
      const insiraCupom = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Digite um código de cupom para aplicar", iconAlerta: 'warning' }
      });
    }
    else {
      let customParams = {
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        cupom: this.cupom
      };

      this.hideCL = false;
      this.tmaService.checkCupomPlanos(customParams).subscribe((qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes['res'] == 'done') {
          if (qRes['cupomValido'] == true) {
            //atrelar, 
            this.valorCupom = qRes['valor'];
            this.cupomAplicado = true;
            this.valorDesconto = this.valorCupom;
            this.pagarVTF = this.pagarVT - ((this.pagarVT * this.valorCupom) / 100);
            if (this.pagarVTF < 0) {
              this.pagarVTF = 0;
            }
          }
          else {
            if (qRes['cupomUtilizado'] == true) {
              const jaUtilizou = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { tituloAlerta: "Aviso", textoAlerta: "Você já utilizou este cupom anteriormente", iconAlerta: 'warning' }
              });
            }
            else {
              const cupomInv = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { tituloAlerta: "Aviso", textoAlerta: "O código digitado não é válido. Verifique ou digite outro código e tente novamente", iconAlerta: 'warning' }
              });
            }
          }
        }
      },
        (error) => {
          this.hideCL = true;
          const erroCriar2 = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }


  }

  removerCupom(): void {
    this.cupomAplicado = false;
    this.cupom = '';
    this.valorDesconto = 0;
    this.valorCupom = 0;
    this.pagarVTF = this.pagarVT;
  }

  obterSH(): void {
    var qHash = "";
    var nCarregou = 0;
    var $this = this;
    PagSeguroDirectPayment.onSenderHashReady(function (response) {
      if (response.status == 'error') {
        console.log(response.message);
        //nCarregou = 1;
        $this.carregouSH = false;
        return false;
      }
      else {
        console.log(response);
        //nCarregou = 0;
        //qHash = response.senderHash;
        $this.userSenderHash = response.senderHash;
        $this.carregouSH = true;
      }

    });
    // if (nCarregou == 1) {
    //   //erro
    //   this.carregouSH = false;
    // }
  }



  triggerSH(): void {
    console.log("trigger");
    if (!this.carregouSH) {
      this.obterSH();
      this.carregouSH = true;
      console.log("call sh");
    }
  }



  changeValorP(qEvent: any): void {
    console.log(qEvent);
    this.qPlanoId = qEvent.value;
    //check price
    if (this.arrPlanosPremium.find(x => x.Id == qEvent.value).DescontoAtivo) {
      this.pagarVTF = this.arrPlanosPremium.find(x => x.Id == qEvent.value).ValorCD;
      this.pagarVT = this.pagarVTF;

    }
    else {
      this.pagarVTF = this.arrPlanosPremium.find(x => x.Id == qEvent.value).ValorCD;
      this.pagarVT = this.pagarVTF;
    }

    if (this.valorCupom != 0) {
      this.pagarVTF = this.pagarVT - ((this.pagarVT * this.valorCupom) / 100);
    }
    //non negative
    if (this.pagarVTF < 0) {
      this.pagarVTF = 0;
    }

  }


  digitouCEP(info: string): void {
    console.log(info);
    console.log(info.replace(new RegExp("\\-", 'g'), "").length);
    //consultar cep
    if (info.replace(new RegExp("\\-", 'g'), "").replace(new RegExp("\\_", 'g'), "").length == 8) {
      this.hideCL = false;
      console.log("buscando cep");
      var dadosIn = info.replace(new RegExp("\\-", 'g'), "").replace(new RegExp("\\_", 'g'), "") + '/json/';
      this.tmaService.buscarCEPVia(dadosIn)
        .subscribe((qRes) => {
          console.log(qRes);
          if (qRes['erro'] == true) {
            this.hideCL = true;
          }
          else {
            this.hideCL = true;
            this.logradouro = qRes['logradouro'];
            this.bairro = qRes['bairro'];
            this.cidade = qRes['localidade'];
            this.uf = qRes['uf'];
            this.meuInputNumero.nativeElement.focus();
          }
        })
    }

    if (info.replace(new RegExp("\\-", 'g'), "").replace(new RegExp("\\_", 'g'), "").length == 0) {
      this.logradouro = '';
      this.bairro = '';
      this.cidade = '';
      this.uf = '';
    }


  }

  finalizarPgtoP(): void {
    if (this.tmaService.hcIsPro) {
      //profissional, então inserir apenas os planos pro
      if (this.arrPlanosPremium.find(x => x.Id == this.qPlanoId).Tipo !== "Profissional") {
        const alertaPlanoTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Aviso', textoAlerta: 'Você deve escolher um plano do tipo <b>Profissional</b>', iconAlerta: 'warning' }
        })
        return;
      }
    }

    console.log(window.navigator.userAgent);
    console.log(this.qPlanoId);

    var $this = this;

    var objCC = "";

    if (this.pagarVTF > 0) {
      if (this.nomecc == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Nome do Titular</b>', iconAlerta: 'warning' }
        })
        return;
      }


      if (this.numerocc == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Número do Cartão</b>', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.validade == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Para continuar você deve inserir a <b>Validade do Cartão</b>', iconAlerta: 'warning' }
        })
        return;
      }
      else {
        console.log(this.validade.length);
        if (this.validade.length != 7) {
          const alertTipo = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: 'A data de validade deve ser composta pelo mês/ano, exemplo: <b>01/2022</b>', iconAlerta: 'warning' }
          })
          return;
        }
      }

      if (this.cvv == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>Código de Segurança</b> do cartão', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.numerocpf == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>CPF</b> do titular do cartão', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.numerocel == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>Celular</b> do titular do cartão', iconAlerta: 'warning' }
        })
        return;
      }
      
      if (this.nascimento == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira a <b>data de nascimento</b> do titular do cartão', iconAlerta: 'warning' }
        })
        return;
      }
      

      

      this.dadosCC.CardHolderName = this.nomecc;
      this.dadosCC.CardNumber = this.numerocc.replace(/\./g, '');
      this.dadosCC.EndDate = this.validade;
      this.dadosCC.CCV = this.cvv;
    }

    //ao usar rede faz essa chamada
    objCC = JSON.stringify(this.dadosCC);
    console.log(this.dadosCC);
    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idplano: this.qPlanoId,
      dadosCartao: objCC,
      cupom: this.cupom
    };

    this.hideCL = false;
    this.tmaService.checkoutPlanoPremium(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        //redirecionar para finalizado
        if (qRes['pagamento'] == true) {
          this.checkPremiumDone = true;
          this.tmaService.hcPremium = true;
          this.checkPremiumCase = 1;
        }
        else {
          this.checkPremiumDone = true;
          this.checkPremiumCase = 4;
        }

      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao realizar o pagamento. Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar2 = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })



  }

  finalizarPgto(): void {
    //ps
    console.log(window.navigator.userAgent);
    console.log(this.qPlanoId);

    var $this = this;

    if (this.pagarVTF > 0) {
      if (this.nomecc == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Nome do Titular</b>', iconAlerta: 'warning' }
        })
        return;
      }


      if (this.numerocc == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Número do Cartão</b>', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.validade == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Para continuar você deve inserir a <b>Validade do Cartão</b>', iconAlerta: 'warning' }
        })
        return;
      }
      else {
        console.log(this.validade.length);
        if (this.validade.length != 7) {
          const alertTipo = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: 'A data de validade deve ser composta pelo mês/ano, exemplo: <b>01/2022</b>', iconAlerta: 'warning' }
          })
          return;
        }
      }

      if (this.cvv == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>Código de Segurança</b> do cartão', iconAlerta: 'warning' }
        })
        return;
      }

      //rotina ps
      this.hideCL = false;
      var minhaBandeira = "";
      var cardBinFormated = this.numerocc.replace(/\./g, '').toString().substring(0, 6);
      console.log("cad bin " + cardBinFormated);
      PagSeguroDirectPayment.getBrand({
        cardBin: cardBinFormated,
        success: function (response) {
          //bandeira encontrada
          minhaBandeira = response.brand.name;
          console.log("bandeira do cartao");
          console.log(minhaBandeira);
          $this.criarCardToken(minhaBandeira);
        },
        error: function (response) {
          //tratamento do erro
          console.log(response);
          $this.hideCL = true;
        },
        complete: function (response) {
          //tratamento comum para todas chamadas
          console.log(response);
        }
      });

    }
    else {
      //0 já processamos
      this.processarPagamento('');
    }







    //ao usar rede faz essa chamada
    // var objCC = "";
    // this.dadosCC.CardHolderName = this.nomecc;
    // this.dadosCC.CardNumber = this.numerocc.replace(/\./g,'');
    // this.dadosCC.EndDate = this.validade;
    // this.dadosCC.CCV = this.cvv;
    // objCC = JSON.stringify(this.dadosCC);
    // console.log(this.dadosCC);
    // let customParams = {
    //   email: this.tmaService.hcEmail,
    //   senha: this.tmaService.hcSenha,
    //   idplano: this.qPlanoId,
    //   dadosCartao: objCC
    // };





  }

  criarCardToken(qBandeira: any): void {
    var $this = this;
    var mBandeira = qBandeira;
    var meuCardToken = "";
    var mCardNumber = this.numerocc.replace(/\./g, '');
    var mCardCVV = this.cvv;
    var mCardMonth = this.validade.substring(0, 2);
    var mCardYear = this.validade.substring(3, this.validade.length);
    console.log(mCardMonth, mCardYear, mCardNumber, mBandeira, mCardCVV);
    PagSeguroDirectPayment.createCardToken({
      cardNumber: mCardNumber, // Número do cartão de crédito
      brand: mBandeira, // Bandeira do cartão
      cvv: mCardCVV, // CVV do cartão
      expirationMonth: mCardMonth.replace("/", ""), // Mês da expiração do cartão
      expirationYear: mCardYear, // Ano da expiração do cartão, é necessário os 4 dígitos.
      success: function (response) {
        // Retorna o cartão tokenizado.
        console.log("token do cartao");
        console.log(response);
        console.log(response['card'].token);
        meuCardToken = response['card'].token;
        $this.processarPagamento(meuCardToken);
      },
      error: function (response) {
        // Callback para chamadas que falharam.
        console.log(response);
        //se der erro aqui, significa que algo no cartão tá inválido
        $this.hideCL = true;
        $this.alertarCartaoInvalido();
      },
      complete: function (response) {
        // Callback para todas chamadas.
      }
    });
  }

  alertarCartaoInvalido() {
    //this.meuInputCNumber.nativeElement.focus();
    setTimeout(() => {
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: "Erro dados do cartão!", textoAlerta: "Verifique as informações do cartão digitado e tente novamente", iconAlerta: 'warning' }
      })

      return;
    }, 0);

    // const erroCartao = this.dialog.open(AlertaSimplesDialog, {
    //   data: { tituloAlerta: "Erro dados do cartão!",  textoAlerta: "Verifique as informações do cartão digitado e tente novamente", iconAlerta: 'warning' }
    // })
    // return;

  }
  processarPagamento(meuCT: any): void {
    console.log("já temos a bandeira, agora aqui executa tudo");
    //chamada pagseguro
    var objCH = "";
    var objVal = "";

    var formataNT = this.numerocel.replace('(', '').replace(')', '').replace('-', '');
    var fCelDDD = formataNT.substring(0, 2);
    var fCelNum = formataNT.substring(2, formataNT.length);

    objVal = JSON.stringify({ 'senderhash': this.userSenderHash, 'cardtoken': meuCT });
    objCH = JSON.stringify({ 'nome': this.nomecc, 'cpf': this.numerocpf.replace(/\./g, '').replace('-', ''), 'nascimento': this.nascimento, 'celddd': fCelDDD, 'celnumber': fCelNum, 'logradouro': this.logradouro, 'numero': this.numero, 'complemento': this.complemento, 'bairro': this.bairro, 'cidade': this.cidade, 'uf': this.uf, 'cep': this.cep.replace("-", "") });

    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idplano: this.qPlanoId,
      dadosCH: objCH,
      cpfcomprador: this.numerocpf.replace(/\./g, '').replace('-', ''),
      dadosValidar: objVal,
      cupom: this.cupom
    };
    this.hideCL = false;
    //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
    this.tmaService.checkoutPlanoPremiumPS(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        //redirecionar para finalizado
        this.ngZone.run(() => {
          if (qRes['pagamentoStatus'] == 'pago') {
            this.checkPremiumDone = true;
            this.tmaService.hcPremium = true;
            this.checkPremiumCase = 1;
          }
          if (qRes['pagamentoStatus'] == 'gratuito') {
            this.checkPremiumDone = true;
            this.tmaService.hcPremium = true;
            this.checkPremiumCase = 1;
          }
          if (qRes['pagamentoStatus'] == 'aguardando') {
            this.checkPremiumDone = true;
            this.checkPremiumCase = 2;
            //this.tmaService.hcPremium = true;
          }
          if (qRes['pagamentoStatus'] == 'análise') {
            this.checkPremiumDone = true;
            this.checkPremiumCase = 3;
            //this.tmaService.hcPremium = true;
          }
          if (qRes['pagamentoStatus'] == 'negado') {
            this.checkPremiumDone = true;
            this.checkPremiumCase = 4;
            //this.tmaService.hcPremium = true;
          }
          if (qRes['pagamentoStatus'] == 'inválido') {
            this.checkPremiumDone = true;
            this.checkPremiumCase = 5;
            //this.tmaService.hcPremium = true;
          }
        });
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao realizar o pedido. Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar2 = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }

  tryNC(): void {
    this.checkPremiumDone = false;
    this.checkPremiumCase = 0;
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  voltar(): void {
    
    this.router.navigate(['/premium']);
    //this._location.back();
    // if(this.tmaService.paginaAnterior != ""){
    //   this._location.back();
    // }
    // else{
    //   this.router.navigate(['/premium']);
    // }
  }

}
